(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    // Seamless loop for all Shopify-hosted looping videos, HLS included.
  //
  // The native `loop` attribute (and a naive early seek-to-0) causes a visible
  // stutter on HLS (.m3u8) playback: seeking back to byte/segment 0 forces the
  // player to re-fetch the first segment from the CDN, which takes 200-500ms.
  //
  // Fix: keep a second hidden clone of the video buffering from position 0 in
  // the background the whole time the visible one plays. When the visible one
  // fires its native `ended` event (the true end of the clip, not an early
  // cutoff), swap visibility to the clone (already buffered, so the swap is
  // instant) and reset the old one to rebuffer for the next loop.
  function applyDualBufferLoop(video) {
    if (!video.hasAttribute('loop')) return;
    if (video.dataset.seamlessLoopApplied) return;
    video.dataset.seamlessLoopApplied = 'true';
    video.removeAttribute('loop');

    const clone = video.cloneNode(true);
    clone.muted = true;
    clone.removeAttribute('autoplay');
    delete clone.dataset.seamlessLoopApplied;
    clone.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:inherit;opacity:0;pointer-events:none;';

    const parent = video.parentElement;
    if (parent && getComputedStyle(parent).position === 'static') {
      parent.style.position = 'relative';
    }
    parent.appendChild(clone);
    clone.load();

    let active = video;
    let standby = clone;
    let swapping = false;

    function onEnded() {
      if (swapping) return;

      swapping = true;

      standby.currentTime = 0;
      standby.play().catch(() => {});
      standby.style.opacity = '1';

      const prev = active;
      prev.style.opacity = '0';
      prev.removeEventListener('ended', onEnded);

      active = standby;
      standby = prev;
      active.addEventListener('ended', onEnded);

      setTimeout(() => {
        prev.currentTime = 0;
        prev.load();
        swapping = false;
      }, 200);
    }

    video.addEventListener('ended', onEnded);
  }

  function initSeamlessLoops(root) {
    root.querySelectorAll('video[loop]').forEach(applyDualBufferLoop);
  }

  // Patch existing videos on load.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSeamlessLoops(document));
  } else {
    initSeamlessLoops(document);
  }

  // Patch videos injected later (deferred-media, section re-renders).
  const seamlessLoopObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'VIDEO') applyDualBufferLoop(node);
        else node.querySelectorAll?.('video[loop]').forEach(applyDualBufferLoop);
      });
    });
  });
  seamlessLoopObserver.observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
